(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-catalogue-links"] && !Shopify.designMode) return;
  try {
    
(() => {
  const galleries = new WeakMap();
  const startGallery = (root) => {
    if (galleries.has(root)) return;
    const source = root.querySelector('[data-ll-guide-gallery-data]');
    const control = root.querySelector('[data-ll-guide-motion]');
    if (!source || !control) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = false;
    let focused = false;
    let destroyed = false;
    const cards = [];
    const allowed = () => !destroyed && !paused && !focused && !document.hidden && !motion.matches;
    const clearCard = (card) => {
      window.clearTimeout(card.timer);
      card.timer = null;
      if (card.finish) card.finish();
    };
    const prepare = (card) => {
      if (!allowed() || !card.visible || card.loading || card.prepared || card.files.length < 2) return;
      let nextPosition = (card.position + 1) % card.files.length;
      let checked = 0;
      while (card.failed.has(nextPosition) && checked < card.files.length) {
        nextPosition = (nextPosition + 1) % card.files.length;
        checked++;
      }
      if (nextPosition === card.position || checked >= card.files.length) return;
      const url = new URL(card.files[nextPosition], card.active.src);
      url.search = '';
      url.searchParams.set('width', Math.min(480, Math.max(240, Math.ceil(card.element.clientWidth * Math.min(window.devicePixelRatio || 1, 2)))));
      card.loading = true;
      card.next.onload = () => {
        card.loading = false;
        card.prepared = true;
        card.nextPosition = nextPosition;
      };
      card.next.onerror = () => {
        card.loading = false;
        card.failed.add(nextPosition);
        prepare(card);
      };
      card.next.src = url.href;
    };
    const schedule = (card, delay = 5200) => {
      window.clearTimeout(card.timer);
      card.timer = null;
      if (!allowed() || !card.visible || card.files.length < 2) return;
      prepare(card);
      card.timer = window.setTimeout(() => {
        card.timer = null;
        if (!allowed() || !card.visible) return;
        if (!card.prepared) {
          schedule(card, 1200);
          return;
        }
        const outgoing = card.active;
        const incoming = card.next;
        incoming.classList.add('is-current');
        outgoing.classList.remove('is-current');
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          window.clearTimeout(card.fadeTimer);
          card.active = incoming;
          card.next = outgoing;
          card.position = card.nextPosition;
          card.prepared = false;
          card.next.onload = null;
          card.next.onerror = null;
          card.next.removeAttribute('srcset');
          card.next.removeAttribute('sizes');
          card.next.removeAttribute('src');
          card.finish = null;
          if (allowed() && card.visible) schedule(card);
        };
        card.finish = finish;
        card.fadeTimer = window.setTimeout(finish, 850);
      }, delay);
    };
    root.querySelectorAll('[data-ll-gallery-key]').forEach((element, order) => {
      const indexes = data.groups[element.dataset.llGalleryKey];
      const active = element.querySelector('.ll-guide-collection-image');
      const holder = element.querySelector('.ll-guide-collection-media');
      if (!indexes || !active || !holder) return;
      const files = indexes.map((index) => data.files[index]).filter((file) => typeof file === 'string' && /^[a-zA-Z0-9_.-]+$/.test(file));
      if (files.length < 2) return;
      const next = document.createElement('img');
      next.className = 'll-guide-collection-image';
      next.alt = '';
      next.width = 480;
      next.height = 480;
      next.decoding = 'async';
      holder.append(next);
      cards.push({element, files, active, next, order, position: 0, nextPosition: 1, failed: new Set(), visible: false, timer: null, fadeTimer: null, finish: null, loading: false, prepared: false});
    });
    const refresh = () => {
      control.hidden = motion.matches || cards.length === 0;
      cards.forEach((card) => {
        clearCard(card);
        if (allowed() && card.visible) schedule(card, 5000 + card.order * 230);
      });
    };
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const card = cards.find((candidate) => candidate.element === entry.target);
        if (!card) continue;
        card.visible = entry.isIntersecting;
        clearCard(card);
        if (allowed() && card.visible) schedule(card, 5000 + card.order * 230);
      }
    }, {threshold: 0.08});
    cards.forEach((card) => observer.observe(card.element));
    const onToggle = () => {
      paused = !paused;
      control.setAttribute('aria-pressed', String(paused));
      control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
      refresh();
    };
    const onFocusIn = () => { focused = true; refresh(); };
    const onFocusOut = (event) => {
      focused = root.contains(event.relatedTarget);
      refresh();
    };
    control.addEventListener('click', onToggle);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', refresh);
    motion.addEventListener('change', refresh);
    const destroy = () => {
      destroyed = true;
      observer.disconnect();
      cards.forEach((card) => {
        clearCard(card);
        card.next.onload = null;
        card.next.onerror = null;
      });
      control.removeEventListener('click', onToggle);
      root.removeEventListener('focusin', onFocusIn);
      root.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('visibilitychange', refresh);
      motion.removeEventListener('change', refresh);
      galleries.delete(root);
    };
    galleries.set(root, destroy);
    refresh();
  };
  const visit = (target, callback) => {
    if (target.matches?.('[data-ll-guide-gallery]')) callback(target);
    target.querySelectorAll?.('[data-ll-guide-gallery]').forEach(callback);
  };
  visit(document, startGallery);
  document.addEventListener('shopify:section:load', (event) => visit(event.target, startGallery));
  document.addEventListener('shopify:section:unload', (event) => visit(event.target, (root) => galleries.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-favourites"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ll-favourites-rail')) {
  customElements.define('ll-favourites-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.list = this.querySelector('[data-ll-favourites-list]');
      this.originals = [...this.list.children];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.position = 0;
      this.cycle = 0;
      this.manualUntil = 0;
      this.blockClickUntil = 0;
      this.lastTime = 0;
      this.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.addEventListener('pointerdown', event => this.pointerDown(event), { signal });
      this.addEventListener('pointermove', event => this.pointerMove(event), { signal, passive:false });
      this.addEventListener('pointerup', event => this.pointerEnd(event), { signal });
      this.addEventListener('pointercancel', event => this.pointerEnd(event), { signal });
      this.addEventListener('lostpointercapture', event => this.pointerEnd(event), { signal });
      this.addEventListener('wheel', event => {
        if (Math.abs(event.deltaX) > 0 || event.shiftKey) this.pause();
      }, { signal, passive:true });
      this.addEventListener('scroll', () => {
        if (Math.abs(this.scrollLeft - this.position) > 1.2) {
          this.pause();
          this.position = this.scrollLeft;
          if (!this.keyboardFocused()) this.setPosition(this.position);
        }
      }, { signal, passive:true });
      this.addEventListener('keydown', event => this.keydown(event), { signal });
      this.addEventListener('focusin', () => this.pause(), { signal });
      this.addEventListener('focusout', () => this.pause(), { signal });
      this.addEventListener('click', event => this.activate(event), { signal, capture:true });
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.rebuild());
      this.resizeObserver.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold:0.05 });
      this.observer.observe(this);
      this.rebuild();
      document.addEventListener('click', event => {
        if (this.opening || !(event.target instanceof Element) || !event.target.closest('[data-ll-open],[data-ll-design-choice]')) return;
        const url = new URL(window.location.href);
        if (url.searchParams.has('ll_favourite')) {
          url.searchParams.delete('ll_favourite');
          history.replaceState(history.state, '', url);
        }
      }, { signal });
      const restore = () => requestAnimationFrame(() => this.restoreFromURL());
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { signal, once:true });
      else restore();
      document.fonts?.ready.then(() => { if (this.isConnected) this.rebuild(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    keyboardFocused() {
      const active = document.activeElement;
      return active instanceof Element && this.contains(active) && active.matches(':focus-visible');
    }
    pause() { this.manualUntil = performance.now() + 8000; }
    rebuild() {
      if (!this.list || !this.originals.length || !this.clientWidth) return;
      const oldCycle = this.cycle;
      const phase = oldCycle ? ((this.scrollLeft % oldCycle) + oldCycle) % oldCycle / oldCycle : 0;
      this.list.querySelectorAll('[data-ll-favourite-copy]').forEach(item => item.remove());
      for (const item of this.originals) {
        const link = item.querySelector('[data-ll-favourite-link]');
        const url = new URL(window.location.href);
        url.hash = 'selection-' + link.dataset.llSelectionKey;
        url.searchParams.set('ll_favourite', link.dataset.llNativeVariant);
        link.href = url.href;
      }
      const first = this.originals[0].getBoundingClientRect();
      const last = this.originals[this.originals.length - 1].getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.cycle = last.right - first.left + gap;
      if (this.originals.length > 1 && this.cycle > 0) {
        const copies = Math.ceil(this.clientWidth / this.cycle) + 1;
        const fragment = document.createDocumentFragment();
        for (let repeat = 0; repeat < copies; repeat++) {
          for (const original of this.originals) {
            const copy = original.cloneNode(true);
            copy.dataset.llFavouriteCopy = 'true';
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-shopify-editor-block');
            copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
            copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
            copy.querySelectorAll('img').forEach(img => img.alt = '');
            fragment.append(copy);
          }
        }
        this.list.append(fragment);
        this.position = this.keyboardFocused() ? this.scrollLeft : this.cycle * (1 + phase);
        this.scrollLeft = this.position;
      } else {
        this.position = this.scrollLeft = 0;
      }
      this.dataset.llCycleWidth = String(this.cycle);
      this.sync();
    }
    setPosition(left) {
      if (this.cycle > 0 && this.originals.length > 1 && !this.keyboardFocused()) {
        left = this.cycle + ((left - this.cycle) % this.cycle + this.cycle) % this.cycle;
      }
      this.position = left;
      this.scrollLeft = left;
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.lastTime = 0;
      if (!this.visible || document.hidden || this.reduced.matches || this.originals.length < 2) {
        this.dataset.llGlideState = this.reduced.matches ? 'reduced-motion' : 'offscreen';
        return;
      }
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (!this.isConnected || !this.visible || document.hidden || this.reduced.matches) return;
      const elapsed = this.lastTime ? Math.min(time - this.lastTime, 80) : 0;
      this.lastTime = time;
      const focus = this.keyboardFocused();
      const dialog = Boolean(document.querySelector('.ll-dialog[open]'));
      const manual = this.drag || time < this.manualUntil;
      this.dataset.llGlideState = dialog ? 'dialog' : focus ? 'keyboard' : manual ? 'manual' : 'running';
      if (!dialog && !focus && !manual) this.setPosition(this.position + elapsed * 0.016);
      else this.position = this.scrollLeft;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    pointerDown(event) {
      this.pause();
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      this.drag = { id:event.pointerId, x:event.clientX, y:event.clientY, left:this.scrollLeft, moved:false };
    }
    pointerMove(event) {
      const drag = this.drag;
      if (!drag || drag.id !== event.pointerId) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
        drag.moved = true;
        this.setPointerCapture(event.pointerId);
        this.dataset.llDragging = 'true';
      }
      if (!drag.moved) return;
      event.preventDefault();
      this.pause();
      const left = drag.left - dx;
      this.setPosition(left);
      drag.left += this.position - left;
    }
    pointerEnd(event) {
      if (!this.drag || this.drag.id !== event.pointerId) { this.pause(); return; }
      const moved = this.drag.moved;
      this.drag = null;
      delete this.dataset.llDragging;
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      if (moved) this.blockClickUntil = performance.now() + 400;
      this.pause();
    }
    keydown(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const links = this.originals.map(item => item.querySelector('[data-ll-favourite-link]'));
      const current = links.indexOf(document.activeElement);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : current < 0 ? (event.key === 'ArrowRight' ? 0 : links.length - 1) : (current + (event.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length;
      if (!links[index]) return;
      event.preventDefault();
      this.pause();
      links[index].focus({ preventScroll:true });
      const left = this.originals[index].offsetLeft - this.originals[0].offsetLeft;
      this.position = left;
      this.scrollTo({ left, behavior:this.reduced.matches ? 'instant' : 'smooth' });
    }
    activate(event) {
      if (performance.now() < this.blockClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest('[data-ll-favourite-link]') : null;
      if (!link || !this.contains(link)) return;
      if (this.openFavourite(link)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    restoreFromURL() {
      if (!this.isConnected || this.restored) return;
      const url = new URL(window.location.href);
      const variant = url.searchParams.get('ll_favourite');
      const link = this.originals.map(item => item.querySelector('[data-ll-favourite-link]')).find(item => item.dataset.llNativeVariant === variant && url.hash === '#selection-' + item.dataset.llSelectionKey);
      if (link) {
        this.restored = true;
        this.openFavourite(link);
      }
    }
    openFavourite(link) {
      const card = document.getElementById('selection-' + link.dataset.llSelectionKey);
      const opener = card?.querySelector('[data-ll-open]');
      const dialog = opener ? document.getElementById(opener.dataset.llOpen) : null;
      const panel = dialog ? [...dialog.querySelectorAll('[data-ll-variant-id]')].find(item => item.dataset.llVariantId === link.dataset.llNativeVariant) : null;
      const choice = panel ? [...dialog.querySelectorAll('[data-ll-design-choice]')].find(item => item.dataset.llDesignChoice === panel.dataset.llPieceId) : null;
      if (!opener || !dialog || !panel || !choice) return false;
      this.pause();
      const pageX = window.scrollX, pageY = window.scrollY;
      this.opening = true;
      card.closest('[data-ll-catalog]')?.revealSelection?.(card);
      opener.click();
      choice.click();
      document.querySelector('ll-showroom')?.fromHash?.();
      this.opening = false;
      const url = new URL(window.location.href);
      url.searchParams.set('ll_favourite', link.dataset.llNativeVariant);
      history.replaceState(history.state, '', url);
      const original = this.originals.map(item => item.querySelector('[data-ll-favourite-link]')).find(item => item.dataset.llFavouriteIndex === link.dataset.llFavouriteIndex);
      dialog.addEventListener('close', () => {
        requestAnimationFrame(() => {
          original?.focus({ preventScroll:true });
          window.scrollTo({ left:pageX, top:pageY, behavior:'instant' });
          this.pause();
        });
      }, { once:true });
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-review-carousel"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ll-review-carousel'))customElements.define('ll-review-carousel',class extends HTMLElement{
async connectedCallback(){
 this.abort?.abort();this.resize?.disconnect();this.viewObserver?.disconnect();cancelAnimationFrame(this.glideFrame);
 this.abort=new AbortController();const signal=this.abort.signal,rail=this.querySelector('.ll-review-rail'),status=this.querySelector('[data-review-status]');
 const template=this.querySelector('.ll-review-rating')?.cloneNode(true);
 let allCards=[...rail.children].filter(c=>!c.dataset.reviewClone&&c.querySelector('.ll-review-photo'));
 try{
  const response=await fetch(this.dataset.reviewFeed,{signal});if(!response.ok)throw Error('Review feed unavailable');
  const data=await response.json();if(signal.aborted||!this.isConnected)return;
  const records=data.records.filter(r=>r.photo&&r.rating>=4&&r.rating<=5);
  if(records.length){
   const make=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;};
   allCards=records.map(r=>{
    const card=make('li','ll-review-card ll-review-card--photo');card.dataset.reviewVariant=r.variant;card.dataset.sourceReviewId=r.id;
    const link=make('a','ll-review-card-link');link.href='#selection-'+r.product;link.dataset.llReviewProductLink='';link.setAttribute('aria-label',r.label+(r.option?' — '+r.option:''));link.draggable=false;
    const photo=make('span','ll-review-photo');const alt='Customer review photo by '+r.author;
    const image=make('img');image.src=r.photo;image.width=112;image.height=144;image.loading='lazy';image.alt=alt;image.draggable=false;photo.append(image);
    const copy=make('div','ll-review-card-copy'),label=make('span','ll-review-product',r.label);label.dataset.productUrl='#selection-'+r.product;copy.append(label);
    if(template){const rating=template.cloneNode(true);rating.querySelector('.ll-review-stars').setAttribute('aria-label',r.rating+' out of 5 stars');rating.querySelector('.ll-review-stars-fill').style.width=(r.rating*20)+'%';rating.querySelector('.ll-review-rating-number').textContent=r.rating+'/5';copy.append(rating);}
    if(r.text)copy.append(make('p','ll-highlight-review-summary',r.text));
    const footer=make('div','ll-review-card-footer');if(r.option)footer.append(make('p','ll-review-option',r.option));
    const author=make('p','ll-review-author',r.author);if(r.date){author.append(document.createTextNode(' · '));const date=make('time');date.dateTime=r.date;date.textContent=new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}).format(new Date(r.date+'T12:00:00Z'));author.append(date);}
    footer.append(author);copy.append(footer);link.append(photo,copy);card.append(link);return card;
   });
  }
 }catch(error){if(signal.aborted)return;}
 if(!allCards.length)return;
 const syncProducts=()=>allCards.forEach(review=>{
  const label=review.querySelector('.ll-review-product');let panel=[...document.querySelectorAll('[data-ll-selection-panel][data-ll-variant-id]')].find(e=>e.dataset.llVariantId===review.dataset.reviewVariant),card=panel?.closest('[data-ll-selection]');
  const title=card?.querySelector('.ll-card-action h3')?.textContent?.trim();if(title){label.textContent=title;label.dataset.productUrl='#'+card.id;}
  const link=review.querySelector('[data-ll-review-product-link]'),opener=card?.querySelector('[data-ll-open]');
  if(link&&card){link.href='#'+card.id;if(opener)link.dataset.llOpen=opener.dataset.llOpen;if(panel)link.dataset.llReviewPiece=panel.dataset.llPieceId;}
 });
 syncProducts();
 rail.replaceChildren(...allCards);allCards.forEach(card=>card.hidden=false);
 const duplicate=card=>{const clone=card.cloneNode(true);clone.dataset.reviewClone='true';clone.setAttribute('aria-hidden','true');clone.querySelectorAll('button,a,[tabindex]').forEach(e=>e.tabIndex=-1);return clone;};
 rail.prepend(...allCards.map(duplicate));rail.append(...allCards.map(duplicate));
 this.dataset.reviewCount=String(allCards.length);this.querySelector('[data-review-more]')?.remove();
 let step=0,cycle=0,visible=1,position=0,lastTime=0,inView=false,resumeAt=0,drag=null,suppressUntil=0,normalizing=false;
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const logical=left=>cycle?((left-cycle)%cycle+cycle)%cycle:0;
 const pause=()=>{resumeAt=performance.now()+6500;position=rail.scrollLeft;};
 const normalise=()=>{if(normalizing||!cycle)return;const left=rail.scrollLeft;if(left<cycle-.5||left>=cycle*2-.5){normalizing=true;rail.scrollLeft=cycle+logical(left);position=rail.scrollLeft;normalizing=false;}};
 const statusUpdate=()=>{if(!step)return;const first=Math.floor((logical(rail.scrollLeft)+.5)/step)%allCards.length;const last=(first+visible-1)%allCards.length;
  clearTimeout(this.timer);this.timer=setTimeout(()=>{if(status)status.textContent=this.dataset.statusTemplate.replace('__first__',String(first+1)).replace('__last__',String(Math.min(allCards.length,first+visible))).replace('__count__',String(allCards.length));},180);
 };
 const measure=()=>{const previous=step?logical(rail.scrollLeft)/step:0;const gap=parseFloat(getComputedStyle(rail).columnGap)||0;step=allCards[0].getBoundingClientRect().width+gap;cycle=step*allCards.length;visible=Math.min(allCards.length,Math.max(1,Math.round((rail.clientWidth+gap)/step)));rail.scrollLeft=cycle+previous*step;position=rail.scrollLeft;statusUpdate();};
 const move=delta=>{pause();const current=Math.round(logical(rail.scrollLeft)/step),target=((current+delta)%allCards.length+allCards.length)%allCards.length;rail.scrollLeft=cycle+target*step;position=rail.scrollLeft;statusUpdate();};
 rail.addEventListener('scroll',()=>{normalise();statusUpdate();},{signal,passive:true});
 rail.addEventListener('keydown',event=>{if(event.target!==rail||event.altKey||event.ctrlKey||event.metaKey||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();if(event.key==='Home'||event.key==='End'){pause();rail.scrollLeft=cycle+(event.key==='End'?(allCards.length-1)*step:0);position=rail.scrollLeft;}else move(event.key==='ArrowRight'?1:-1);},{signal});
 rail.addEventListener('wheel',pause,{signal,passive:true});rail.addEventListener('touchstart',pause,{signal,passive:true});rail.addEventListener('click',event=>{
  pause();const link=event.target.closest('[data-ll-review-product-link]');if(!link||event.button>0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  const dialog=document.getElementById(link.dataset.llOpen),choice=dialog?.querySelector('[data-ll-design-choice="'+link.dataset.llReviewPiece+'"]');choice?.click();
 },{signal});
 window.addEventListener('click',event=>{if(this.contains(event.target)&&event.detail!==0&&performance.now()<suppressUntil){event.preventDefault();event.stopImmediatePropagation();}},{signal,capture:true});
 rail.addEventListener('dragstart',event=>event.preventDefault(),{signal});
 rail.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;pause();if(event.clientY>=rail.getBoundingClientRect().top+rail.clientHeight)return;drag={x:event.clientX,left:rail.scrollLeft,moved:false};},{signal});
 window.addEventListener('pointermove',event=>{if(!drag)return;const dx=event.clientX-drag.x;if(Math.abs(dx)>6){drag.moved=true;rail.scrollLeft=drag.left-dx;position=rail.scrollLeft;}},{signal});
 window.addEventListener('pointerup',()=>{if(!drag)return;const moved=drag.moved;drag=null;pause();if(moved)suppressUntil=performance.now()+350;},{signal});
 rail.addEventListener('pointercancel',()=>{drag=null;pause();},{signal});
 this.viewObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;},{threshold:.15});this.viewObserver.observe(this);
 const tick=time=>{
  const elapsed=lastTime?Math.min(50,time-lastTime):0;lastTime=time;
  const focus=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');
  const blocked=time<resumeAt||!inView||document.hidden||motion.matches||focus||drag;
  this.dataset.glideState=!inView?'out-of-view':document.hidden?'hidden':motion.matches?'reduced-motion':focus?'focus':time<resumeAt?'manual-pause':'running';
  if(blocked)position=rail.scrollLeft;
  else if(cycle&&allCards.length>visible){position+=elapsed*.018;if(position>=cycle*2)position-=cycle;rail.scrollLeft=position;}
  this.glideFrame=requestAnimationFrame(tick);
 };
 this.resize=new ResizeObserver(measure);this.resize.observe(rail);measure();this.glideFrame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.glideFrame);this.viewObserver?.disconnect();this.abort?.abort();this.resize?.disconnect();clearTimeout(this.timer);}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-updates-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ll-updates')) {
  customElements.define('ll-updates', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('.ll-updates-toggle');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const setPaused = paused => {
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume updates' : 'Pause updates');
      };
      button.addEventListener('click', () => setPaused(this.dataset.paused !== 'true'));
      motion.addEventListener('change', event => { if (event.matches) setPaused(true); });
      setPaused(motion.matches);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
